module.exports = __webpack_public_path__ + "img/130.fc15a5c5.svg";